import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Select } from 'antd'
import React from 'react'

export function BestRackSelect({ optionsMetadata, bestTerminal, bestSupplyZone, bestRackOnSelect }) {
  const { Option } = Select
  return (
    <Vertical className='h-100' style={{ margin: '50px 75px' }}>
      <div>
        <Texto category='h3' appearance='bold' align='center' style={{ paddingBottom: '20px' }}>
          Best Rack Option
        </Texto>
        <Texto category='p2' align='center'>
          <b>
            This will set a default supply to the best rack option at the selected location(s) at the time of order
            creation.
          </b>
          You can apply this default by a supply zone (group of terminals), or by a specific terminal.
        </Texto>
      </div>
      <Horizontal flex={1} verticalCenter>
        <Vertical verticalCenter>
          <Texto category='p2' appearance='bold'>
            Select a Supply Zone
          </Texto>
          <Select
            showSearch
            allowClear
            style={{ width: '100%' }}
            placeholder='Supply Zones'
            onChange={(_, value) => bestRackOnSelect(value, 'supplyZone')}
            value={bestSupplyZone?.children}
          >
            {optionsMetadata?.supply_zones.map((name) => {
              return <Option key={name}>{name}</Option>
            })}
          </Select>
        </Vertical>
        <Vertical verticalCenter>
          <Texto category='h4' align='center' appearance='bold' style={{ margin: '50px' }}>
            OR
          </Texto>
        </Vertical>
        <Vertical verticalCenter>
          <Texto category='p2' appearance='bold'>
            Select a terminal
          </Texto>
          <Select
            showSearch
            allowClear
            style={{ width: '100%', marginTop: '5px' }}
            placeholder='Terminals'
            onChange={(_, value) => bestRackOnSelect(value, 'terminal')}
            value={bestTerminal?.children}
          >
            {optionsMetadata?.terminals.map(({ id, name }) => {
              return (
                <Option key={id} value={name}>
                  {name}
                </Option>
              )
            })}
          </Select>
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}
